export const properties = [
  {
    id: 'portfolio',
    name: 'The Aurelian Collection',
    detail: '6 properties · 1,284 keys',
  },
  { id: 'claridge', name: 'Maison Claridge', detail: 'Paris · 186 keys' },
  { id: 'bellamy', name: 'The Bellamy', detail: 'London · 214 keys' },
  { id: 'palazzo', name: 'Palazzo Aurelia', detail: 'Rome · 172 keys' },
]

export const horizons = {
  '7D': {
    labels: [
      '10 Jul',
      '11 Jul',
      '12 Jul',
      '13 Jul',
      '14 Jul',
      '15 Jul',
      '16 Jul',
    ],
    occupancy: [78, 82, 91, 94, 88, 84, 86],
    lastYear: [72, 77, 84, 88, 81, 79, 80],
  },
  '14D': {
    labels: [
      '10 Jul',
      '12 Jul',
      '14 Jul',
      '16 Jul',
      '18 Jul',
      '20 Jul',
      '23 Jul',
    ],
    occupancy: [78, 91, 88, 86, 90, 83, 79],
    lastYear: [72, 84, 81, 80, 84, 78, 75],
  },
  '30D': {
    labels: [
      '10 Jul',
      '15 Jul',
      '20 Jul',
      '25 Jul',
      '30 Jul',
      '4 Aug',
      '9 Aug',
    ],
    occupancy: [78, 84, 83, 91, 87, 80, 76],
    lastYear: [72, 79, 78, 85, 82, 74, 71],
  },
} as const

export type Horizon = keyof typeof horizons

export const kpis = [
  {
    label: 'Occupancy',
    value: '86.4%',
    change: '+4.8 pts',
    note: 'vs. last year',
  },
  {
    label: 'Average daily rate',
    value: '€742',
    change: '+7.2%',
    note: 'vs. forecast',
  },
  { label: 'RevPAR', value: '€641', change: '+12.6%', note: 'vs. last year' },
  {
    label: 'Rooms revenue',
    value: '€5.84M',
    change: '+€380K',
    note: 'next 30 days',
  },
]

export const events = [
  {
    date: '12–14',
    month: 'JUL',
    title: 'Paris Couture Week',
    impact: 'Very high',
    rooms: '+184 rooms',
    distance: '1.2 km',
  },
  {
    date: '18',
    month: 'JUL',
    title: 'Bastille Gala at Opéra',
    impact: 'High',
    rooms: '+72 rooms',
    distance: '0.8 km',
  },
  {
    date: '22–24',
    month: 'JUL',
    title: 'Global Finance Forum',
    impact: 'High',
    rooms: '+116 rooms',
    distance: '2.4 km',
  },
]

export const competitors = [
  { name: 'Maison Claridge', rate: 890, delta: 'Your property', own: true },
  { name: 'Hôtel Beaumont', rate: 960, delta: '+7.9%', own: false },
  { name: 'Le Grand Lys', rate: 845, delta: '−5.1%', own: false },
  { name: 'The Vendôme', rate: 925, delta: '+3.9%', own: false },
]

export const vipAlerts = [
  {
    initials: 'EC',
    name: 'Elena Caspari',
    tier: 'Royal Circle',
    stay: 'Arriving today · 4 nights',
    detail: 'Penthouse preference · 12 prior stays',
    accent: 'Presidential suite upgrade pending',
  },
  {
    initials: 'JM',
    name: 'James Montrose',
    tier: 'Ambassador',
    stay: 'Arriving 12 Jul · 3 nights',
    detail: 'Anniversary stay · Airport transfer confirmed',
    accent: 'Welcome amenity requires approval',
  },
]
